// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"291d5bd5","453":"5c3e7dd1"}[chunkId] + ".chunk.js";
};